import { allergenDetectManifest } from "./manifest/allergen-detect"
import { menuDetectMetadataManifest } from "./manifest/menu-detect-metadata"
import { menuTranslateManifest } from "./manifest/menu-translate"
import { productsDetectMetadataManifest } from "./manifest/products-detect-metadata"
import { textGenerateManifest } from "./manifest/text-generate"
import { translateProductsManifest } from "./manifest/translate-products"

export const operationManifestList = [
	allergenDetectManifest,
	menuDetectMetadataManifest,
	menuTranslateManifest,
	productsDetectMetadataManifest,
	textGenerateManifest,
	translateProductsManifest,
] as const

type Manifest = (typeof operationManifestList)[number]

export type OperationType = Manifest["type"]

type ManifestByType = {
	[M in Manifest as M["type"]]: M
}

function registryKeyForType(type: string) {
	return type.replaceAll(".", "_").toUpperCase()
}

export const operationManifestByType = Object.fromEntries(
	operationManifestList.map((manifest) => [manifest.type, manifest]),
) as ManifestByType

export const OPERATION_KEYS = Object.fromEntries(
	operationManifestList.map((manifest) => [
		registryKeyForType(manifest.type),
		manifest.type,
	]),
) as Record<string, OperationType>

export type OperationKey = OperationType

export function bocLabelKeyForOperation(type: string): string | undefined {
	return operationManifestByType[type as OperationType]?.bocLabelKey
}

/**
 * Last dotted segment of a fully-qualified translation key. Used to reshape
 * `operations.boc.types.allergenDetect` → `allergenDetect` so consumer apps
 * can nest translations under `boc.types.{leaf}` without stringly-typed drift.
 */
type LastSegment<S extends string> = S extends `${string}.${infer Rest}`
	? LastSegment<Rest>
	: S

/**
 * Leaf key each locale's `boc.types` object is indexed by — kept in the
 * `@foodlista/operations` package so the translation-side `satisfies` check
 * fails at compile time when a new manifest is added but a locale forgot to
 * register its label.
 */
export type BocTypeLeafKey = LastSegment<Manifest["bocLabelKey"]>
